export enum PhishingAction {
  REMOVE_FROM_ALLOWLIST = "removeFromAllowlist",
  REMOVE_FROM_BLOCKLIST = "removeFromBlocklist",
  ADD_TO_ALLOWLIST = "addToAllowlist",
  ADD_TO_BLOCKLIST = "addToBlocklist",
  IMPORT_ALLOW_BLOCK_LIST = "importAllowBlockListFromCsv",
  DOWNLOAD_ALLOW_BLOCK_LIST_EXAMPLE_CSV = "downloadAllowBlockListExampleCsv",
}

export enum AllowListSubType {
  AUTH_FAILURE = "auth",
  SUSPICIOUS_CONTENT = "local",
}

export enum AllowBlockListType {
  ALLOW = "allow",
  BLOCK = "block",
}

export enum EmailSecurityAllowBlockItemType {
  DOMAIN = "domain",
  EMAIL = "email",
  IP = "ip",
  IP_RANGE = "ipRange",
  COUNTRY = "country",
  TLD = "tld",
}

export enum AllowBlockListTab {
  EMAILS_DOMAINS = "emailsOrDomains",
  IPS_IP_RANGES = "ipsIpRanges",
  COUNTRIES = "countries",
  TLDS = "tlds",
}

export enum AllowBlockTermsFieldType {
  FREE_TEXT = "freeText",
  OPTIONS = "options",
}

/**
 * Why a TLD offered by the picker cannot be selected. TLDs the backend reports as
 * restricted can never be blocked; TLDs already on the current workspace's list are
 * only unavailable here (ES-5489 deliberately does not check parent workspaces).
 */
export enum TldOptionState {
  AVAILABLE = "available",
  RESTRICTED = "restricted",
  ALREADY_ON_LIST = "alreadyOnList",
}

/**
 * BE now supports effectively all countries, only the deprecated
 * "AN" (Netherlands Antilles) is absent
 */
export const UNSUPPORTED_GEO_BLOCK_COUNTRIES = ["AN"];
